import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ROUTES } from '@/config/routes';

const BrandAnalyserPage = lazy(() =>
  import('./routes/BrandAnalyserPage').then((m) => ({ default: m.BrandAnalyserPage })),
);

/**
 * The Brand Analyser screen.
 *
 * <p>**Listed inside the `<ProductRoute />` group in `app/router`**, so `brand_intelligence`
 * is demanded by placement; `screenForPath` resolves it from `app/navigation/screens.ts`.
 * Listed before `placeholderRoutes`, whose entry for this path disappears once
 * `ROUTES.brandAnalyser` is in its `BUILT_ROUTES`.
 *
 * <p>The two screens its cards link to — the brand overview and the review form — are not
 * ported, and are work-in-progress routes in `features/placeholder` until they are.
 */
export const brandAnalyserRoutes: RouteObject[] = [
  { path: ROUTES.brandAnalyser, element: <BrandAnalyserPage /> },
];

export { useAnalyseDomain } from './hooks/useAnalyseDomain';
